/**
 * Store状态管理入口文件 (v2)
 * @description 统一导出所有v2 Store模块
 */
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

// 导出Store模块
export { useAppStore } from './modules/app'
export { useDesignerStore } from './modules/designer'
export { useModelStore } from './modules/model'
export { useUserCenterNavigationStore as useNavigationStore } from './modules/navigation'
export { useSettingsStore } from './modules/settings'
export { useBidStore, useDeliveryStore, useTaskStore } from './modules/task'
export { useUserStorev2 as useUserStore } from './modules/userCenter'
export { usePublishedTaskStore } from './userCenter/publishedTask'

// 导出Store实例创建函数和类型
export { setActivePinia } from 'pinia'
export type { StoreGeneric } from 'pinia'

// 创建并配置Pinia实例
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

export { createPinia }
export default pinia
